module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Bold.woff2?v=818e1dba89beb3bb671827ae0309ca1b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Bold.woff2
// module id = 644
// module chunks = 0